import { Classification } from '@models/Classification';
import { Response } from '@models/Response';
import * as api from './api';

export function get(): Promise<Response<Classification>> {
  return api.get('classifications');
}
